import * as React from 'react';
import {client} from '@logilab/cwclientlibjs';
import {TranslationContext} from './commons';

export const JSONQueryResults: React.FC<{rows: client.RqlRows}> = ({rows}) => {
    return <pre>{JSON.stringify(rows, null, 4)}</pre>;
};

export const TableQueryResults: React.FC<{
    rows: client.RqlRows;
    queryVariables: string[] | null;
}> = ({rows, queryVariables}) => {
    if (rows.length === 0) {
        return (
            <TranslationContext.Consumer>
                {(tc) => (
                    <span className="results-empty">
                        {tc.translate(
                            'This query did not retrieve any results.'
                        )}
                    </span>
                )}
            </TranslationContext.Consumer>
        );
    }
    return (
        <table className="table">
            {queryVariables !== null ? (
                <thead>
                    <tr>
                        {queryVariables.map(
                            (variable: string, index: number) => (
                                <th key={index}>{variable}</th>
                            )
                        )}
                    </tr>
                </thead>
            ) : (
                <></>
            )}
            <tbody>
                {rows.map((row: client.RqlRow, index: number) => (
                    <tr key={index}>
                        {row.map((value: any, index: number) => (
                            <td
                                key={index}
                                className={
                                    isNaN(Number(value)) ? 'string' : 'number'
                                }
                            >
                                {value}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export const TabbedQueryResults: React.FC<{
    rows: client.RqlRows;
    queryVariables: string[] | null;
}> = ({rows, queryVariables}) => {
    const [displayMode, setDisplayMode] = React.useState<'table' | 'json'>(
        'table'
    );
    const tabForMode = (mode: 'table' | 'json', name: string) => {
        return (
            <li className={`tab ${displayMode === mode ? 'tab-selected' : ''}`}>
                <button
                    className="tab-button"
                    onClick={() => setDisplayMode(mode)}
                >
                    {name}
                </button>
            </li>
        );
    };
    return (
        <div className="tabbed-results">
            <div className="tabs">
                <ul className="tab-list">
                    {tabForMode('table', 'Table')}
                    {tabForMode('json', 'JSON')}
                </ul>
            </div>
            <div className="results">
                {displayMode === 'table' && (
                    <TableQueryResults
                        queryVariables={queryVariables}
                        rows={rows}
                    />
                )}
                {displayMode === 'json' && <JSONQueryResults rows={rows} />}
            </div>
        </div>
    );
};

export const QueryError: React.FC<{reason: string}> = ({reason}) => {
    return (
        <TranslationContext.Consumer>
            {(tc) => (
                <div className="rql-querier-error">
                    <span>
                        {tc.translate('We detected an error with your query:')}
                    </span>
                    <br />
                    <span className="error-reason">{reason}</span>
                </div>
            )}
        </TranslationContext.Consumer>
    );
};
